import { ActivityEvent } from "./activityEvent";
import { Location } from '../../model/location';
import { DayPilot } from "daypilot-pro-angular";
import { WorkShift } from "../../model/workShift";
import { ActivityActor } from "../../model/activityActor";

export class ActivityDialogEvent {

  constructor(
    public activityEvent: ActivityEvent,
    public command: string,
    public existing: boolean,
    public locations: Location[],
    public end: DayPilot.Date,
    public mode: string,
    public state: string,
    public activityActor: ActivityActor,
    public unassign: boolean,
    public cancel: boolean,
    public workShifts: WorkShift[]) {
  }
}
